'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./sg-dashboard-highcharts-v10.cjs.production.min.js');
} else {
  module.exports = require('./sg-dashboard-highcharts-v10.cjs.development.js');
}